import { render, staticRenderFns } from "./AcademyTeachers.vue?vue&type=template&id=7eec8a50&scoped=true&lang=pug&"
import script from "./AcademyTeachers.vue?vue&type=script&lang=ts&"
export * from "./AcademyTeachers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eec8a50",
  null
  
)

export default component.exports